var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngilshScoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92915 6.09668L3.47754 7.49668H4.38076L3.92915 6.09668Z",
    fill: "#213C92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6452 0H5.41935V2.25806H7.22581V3.16129H1.35484C0.587097 3.16129 0 3.74839 0 4.51613V9.48387C0 10.2516 0.587097 10.8387 1.35484 10.8387H1.80645V13.1419L4.65161 10.8387H7.67742V7.67742H12.6452C13.4129 7.67742 14 7.09032 14 6.32258V1.35484C14 0.587097 13.4129 0 12.6452 0ZM4.87742 8.9871L4.65161 8.26452H3.25161L2.98064 8.9871H1.89677L3.3871 4.96774H4.47097L5.96129 8.9871H4.87742ZM11.7419 5.41935V6.32258C11.1548 6.32258 10.5226 6.14194 9.98065 5.87097C9.43871 6.14194 8.80645 6.27742 8.17419 6.32258L8.12903 5.41935C8.44516 5.41935 8.76129 5.37419 9.07742 5.28387C8.67097 4.87742 8.4 4.38065 8.26452 3.83871H9.2129C9.34839 4.24516 9.61935 4.56129 9.93548 4.83226C10.4323 4.42581 10.7484 3.83871 10.7935 3.16129H8.08387V2.25806H9.43871V1.35484H10.3419V2.25806H11.8323L11.8774 2.70968C11.9226 3.65806 11.5613 4.60645 10.8839 5.28387C11.2 5.37419 11.471 5.41935 11.7419 5.41935Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngilshScoreIcon);
export default __webpack_public_path__ + "static/media/engilsh-score-icon.68ddd8339a8586cd3c7930a0cfe4a8e6.svg";
export { ForwardRef as ReactComponent };